function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const DEFAULT_LOCALES = ['en', 'fr'];

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

const getPropertyId = repo => {
  if (!repo) return null;
  if (!repo.context) return null;
  const {
    propertyId
  } = repo.context.serialize();
  return propertyId || null;
};

const getPropertyLocales = _async(function (repo
/*: Object*/
)
/*: Promise<Array<string>>*/
{
  const propertyId = getPropertyId(repo); // HACK: There's no property for Businesses and Locations so we'll return all valid locales in that case

  return propertyId ? _await(repo.client.properties.for(propertyId).getLocales(), function (_repo$client$properti) {
    return _repo$client$properti.locales;
  }) : DEFAULT_LOCALES;
});

module.exports = getPropertyLocales;